/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  ErrorLimited,
  GatewayTimeout,
  GetDogmaAttributesAttributeIdNotFound,
  GetDogmaAttributesAttributeIdOk,
  GetDogmaDynamicItemsTypeIdItemIdNotFound,
  GetDogmaDynamicItemsTypeIdItemIdOk,
  GetDogmaEffectsEffectIdNotFound,
  GetDogmaEffectsEffectIdOk,
  InternalServerError,
  ServiceUnavailable,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    ErrorLimitedFromJSON,
    ErrorLimitedToJSON,
    GatewayTimeoutFromJSON,
    GatewayTimeoutToJSON,
    GetDogmaAttributesAttributeIdNotFoundFromJSON,
    GetDogmaAttributesAttributeIdNotFoundToJSON,
    GetDogmaAttributesAttributeIdOkFromJSON,
    GetDogmaAttributesAttributeIdOkToJSON,
    GetDogmaDynamicItemsTypeIdItemIdNotFoundFromJSON,
    GetDogmaDynamicItemsTypeIdItemIdNotFoundToJSON,
    GetDogmaDynamicItemsTypeIdItemIdOkFromJSON,
    GetDogmaDynamicItemsTypeIdItemIdOkToJSON,
    GetDogmaEffectsEffectIdNotFoundFromJSON,
    GetDogmaEffectsEffectIdNotFoundToJSON,
    GetDogmaEffectsEffectIdOkFromJSON,
    GetDogmaEffectsEffectIdOkToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
} from '../models/index';

export interface GetDogmaAttributesRequest {
    datasource?: GetDogmaAttributesDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetDogmaAttributesAttributeIdRequest {
    attributeId: number;
    datasource?: GetDogmaAttributesAttributeIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetDogmaDynamicItemsTypeIdItemIdRequest {
    itemId: number;
    typeId: number;
    datasource?: GetDogmaDynamicItemsTypeIdItemIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetDogmaEffectsRequest {
    datasource?: GetDogmaEffectsDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetDogmaEffectsEffectIdRequest {
    effectId: number;
    datasource?: GetDogmaEffectsEffectIdDatasourceEnum;
    ifNoneMatch?: string;
}

/**
 * 
 */
export class DogmaApi extends runtime.BaseAPI {

    /**
     * Get a list of dogma attribute ids  ---  This route expires daily at 11:05
     * Get attributes
     */
    async getDogmaAttributesRaw(requestParameters: GetDogmaAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/dogma/attributes/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of dogma attribute ids  ---  This route expires daily at 11:05
     * Get attributes
     */
    async getDogmaAttributes(requestParameters: GetDogmaAttributesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getDogmaAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a dogma attribute  ---  This route expires daily at 11:05
     * Get attribute information
     */
    async getDogmaAttributesAttributeIdRaw(requestParameters: GetDogmaAttributesAttributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDogmaAttributesAttributeIdOk>> {
        if (requestParameters['attributeId'] == null) {
            throw new runtime.RequiredError(
                'attributeId',
                'Required parameter "attributeId" was null or undefined when calling getDogmaAttributesAttributeId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/dogma/attributes/{attribute_id}/`.replace(`{${"attribute_id"}}`, encodeURIComponent(String(requestParameters['attributeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDogmaAttributesAttributeIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a dogma attribute  ---  This route expires daily at 11:05
     * Get attribute information
     */
    async getDogmaAttributesAttributeId(requestParameters: GetDogmaAttributesAttributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDogmaAttributesAttributeIdOk> {
        const response = await this.getDogmaAttributesAttributeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns info about a dynamic item resulting from mutation with a mutaplasmid.  ---  This route expires daily at 11:05
     * Get dynamic item information
     */
    async getDogmaDynamicItemsTypeIdItemIdRaw(requestParameters: GetDogmaDynamicItemsTypeIdItemIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDogmaDynamicItemsTypeIdItemIdOk>> {
        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling getDogmaDynamicItemsTypeIdItemId().'
            );
        }

        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling getDogmaDynamicItemsTypeIdItemId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/dogma/dynamic/items/{type_id}/{item_id}/`.replace(`{${"item_id"}}`, encodeURIComponent(String(requestParameters['itemId']))).replace(`{${"type_id"}}`, encodeURIComponent(String(requestParameters['typeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDogmaDynamicItemsTypeIdItemIdOkFromJSON(jsonValue));
    }

    /**
     * Returns info about a dynamic item resulting from mutation with a mutaplasmid.  ---  This route expires daily at 11:05
     * Get dynamic item information
     */
    async getDogmaDynamicItemsTypeIdItemId(requestParameters: GetDogmaDynamicItemsTypeIdItemIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDogmaDynamicItemsTypeIdItemIdOk> {
        const response = await this.getDogmaDynamicItemsTypeIdItemIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of dogma effect ids  ---  This route expires daily at 11:05
     * Get effects
     */
    async getDogmaEffectsRaw(requestParameters: GetDogmaEffectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/dogma/effects/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of dogma effect ids  ---  This route expires daily at 11:05
     * Get effects
     */
    async getDogmaEffects(requestParameters: GetDogmaEffectsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getDogmaEffectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a dogma effect  ---  This route expires daily at 11:05
     * Get effect information
     */
    async getDogmaEffectsEffectIdRaw(requestParameters: GetDogmaEffectsEffectIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDogmaEffectsEffectIdOk>> {
        if (requestParameters['effectId'] == null) {
            throw new runtime.RequiredError(
                'effectId',
                'Required parameter "effectId" was null or undefined when calling getDogmaEffectsEffectId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v2/dogma/effects/{effect_id}/`.replace(`{${"effect_id"}}`, encodeURIComponent(String(requestParameters['effectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDogmaEffectsEffectIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a dogma effect  ---  This route expires daily at 11:05
     * Get effect information
     */
    async getDogmaEffectsEffectId(requestParameters: GetDogmaEffectsEffectIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDogmaEffectsEffectIdOk> {
        const response = await this.getDogmaEffectsEffectIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetDogmaAttributesDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetDogmaAttributesDatasourceEnum = typeof GetDogmaAttributesDatasourceEnum[keyof typeof GetDogmaAttributesDatasourceEnum];
/**
 * @export
 */
export const GetDogmaAttributesAttributeIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetDogmaAttributesAttributeIdDatasourceEnum = typeof GetDogmaAttributesAttributeIdDatasourceEnum[keyof typeof GetDogmaAttributesAttributeIdDatasourceEnum];
/**
 * @export
 */
export const GetDogmaDynamicItemsTypeIdItemIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetDogmaDynamicItemsTypeIdItemIdDatasourceEnum = typeof GetDogmaDynamicItemsTypeIdItemIdDatasourceEnum[keyof typeof GetDogmaDynamicItemsTypeIdItemIdDatasourceEnum];
/**
 * @export
 */
export const GetDogmaEffectsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetDogmaEffectsDatasourceEnum = typeof GetDogmaEffectsDatasourceEnum[keyof typeof GetDogmaEffectsDatasourceEnum];
/**
 * @export
 */
export const GetDogmaEffectsEffectIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetDogmaEffectsEffectIdDatasourceEnum = typeof GetDogmaEffectsEffectIdDatasourceEnum[keyof typeof GetDogmaEffectsEffectIdDatasourceEnum];
